import { IPromise } from 'angular';

import { RequestHelper } from '../helpers/RequestHelper';
import { ResultHelper } from '../helpers/ResultHelper';
import { Module } from '../Module';
import { DeleteFlowVersionsRequest } from '../ServerApi/requests/DeleteFlowVersionsRequest';
import { GetFlowVersionsRequest, GetFlowVersionsResult } from '../ServerApi/requests/GetFlowVersionsRequest';
import { FlowRevision } from '../ServerApi/types/IContentRevision';
import { IResult } from '../ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { FetcherFactory } from '../services/FetcherFactory';
import { ServerService } from '../services/ServerService';
import { Resource } from './Resource';

export class FlowRevisions extends Resource<FlowRevision>  {

  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory'];

  private server: ServerService;

  constructor(private ErrorNotifyingServer: ErrorNotifyingServer, FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetFlowVersionsRequest,
      (result: GetFlowVersionsResult) => result.versions));

    this.server = ErrorNotifyingServer.getServerService();
  }

  public del = (id: string): IPromise<IResult> => {
    return this.ErrorNotifyingServer.sendRequestsAndDelay(
      RequestHelper.buildRequests([id], (idsBlock) => new DeleteFlowVersionsRequest(idsBlock)),
      ResultHelper.combineResults);
  }
}

Module.instance().service('FlowRevisions', FlowRevisions);
